import type { NavigationStateStore } from '../types';

export const resetState = (): NavigationStateStore => ({});
